import axios from "axios";

import { api } from "./api";

export const uploadFileToS3 = async (
  file: File,
  onUploadProgress?: (progressEvent: ProgressEvent) => void
) => {
  try {
    const { url, path } = await api.post<
      { extension: string },
      { url: string; path: string }
    >("/v1/presigned-s3-url", {
      extension: file.name.split(".").pop(),
    });

    await axios.put(url, file, {
      onUploadProgress,
      headers: {
        "Content-Type": file.type,
      },
    });

    return path;
  } catch (err) {
    return;
  }
};
